export default {
  "container": "_container_1rf8gi"
};
